module.exports = __webpack_public_path__ + "img/history-icon.e8b47abb.svg";